import React, { useState } from "react";
import { Logo } from "../../Assets/Images";
import { isDark } from "../../Utils/isDark";
import { useTheme } from "../ThemeProvider/ThemeProvider";

const links = [
  {
    id: 1,
    title: "Markets",
    active: false,
  },
  {
    id: 2,
    title: "Governance",
    active: false,
  },
  {
    id: 3,
    title: "Prices",
    active: false,
  },
  {
    id: 4,
    title: "Docs",
    active: false,
  },
  {
    id: 5,
    title: "Hatom Token",
    active: true,
  },
];

function NavBar() {
  const { themeToggle, theme } = useTheme();
  const [isShow, setIsShow] = useState(false);

  const handleToggleMenu = () => {
    setIsShow((prevIsShow) => !prevIsShow);
  };

  return (
    <header
      className={`px-3 mx-auto flex justify-center w-full items-center text-white text-sm py-5 mb-5 font-semibold z-50 ${
        isShow ? "fixed" : "absolute"
      }`}
    >
      <div className="flex justify-between items-center container">
        <img src={Logo} alt="logo" className="z-50" />
        <nav
          className={`fixed flex-col justify-center ${
            isShow ? "top-0" : "-top-full"
          } transition-all left-0 bg-red h-full w-full md:h-auto md:w-auto md:static md:flex items-center md:ml-20`}
        >
          <ul className="flex h-full flex-col md:flex-row md:bg-none md:dark:bg-none [background-image:linear-gradient(0deg,_#B5D2FF_0%,_#A2BBF7_10%,_#7380E4_30%,_#5960D9_40%,_#3939A1_72%,_#1D166F_100%)] dark:[background-image:linear-gradient(180deg,_#031222_0%,_#0D2B4A_100%)] dark:bg-indigo-1000 justify-center items-center">
            {links.map((link) => (
              <li
                className="px-3 group cursor-pointer py-5 md:py-0"
                key={link.id}
              >
                <span
                  className={`${
                    link.active && "text-blue-700"
                  } group-hover:text-blue-700 transition`}
                >
                  {link.title}
                </span>
                <div
                  className={`${
                    link.active && "bg-blue-900 h-0.5"
                  } group-hover:h-0.5 group-hover:w-full bg-blue-900 mt-1`}
                />
              </li>
            ))}
            <li className="px-3 group cursor-pointer">
              <button className="ml-2" type="button" onClick={themeToggle}>
                <div className="w-6 h-2 rounded-full bg-white dark:bg-emerald-900 relative">
                  <div
                    className={`w-3 h-3 rounded-full absolute bg-emerald-400 -top-0.5 transition-all ${
                      isDark(theme) ? "-right-1" : "-left-1"
                    }`}
                  ></div>
                </div>
              </button>
            </li>
          </ul>
        </nav>
        <div className="flex gap-2">
          <button className="flex items-center gap-2 px-3 py-2 rounded-md bg-bgBtn hover:outline outline-offset-2 outline-1 outline-emerald-800">
            <ElrondIcon />
            Elrond
          </button>
          <button className="hidden md:block px-6 py-2 rounded-md bg-emerald-900 hover:outline outline-offset-2 outline-1 border border-emerald-600 outline-emerald-800">
            App
          </button>
          <button onClick={handleToggleMenu} className="block z-50 md:hidden">
            <div
              className={`h-0.5 w-8 bg-white rounded-sm transition ${
                isShow && "rotate-45 translate-y-2"
              }`}
            ></div>
            <div
              className={`h-0.5 w-8 bg-white rounded-sm my-2 transition ${
                isShow && "opacity-0"
              }`}
            ></div>
            <div
              className={`h-0.5 w-8 bg-white rounded-sm transition ${
                isShow && "-rotate-45 -translate-y-3"
              }`}
            ></div>
          </button>
        </div>
      </div>
    </header>
  );
}

export default NavBar;

function ElrondIcon() {
  return (
    <svg
      className="false"
      xmlns="http://www.w3.org/2000/svg"
      width="14.96"
      height="15"
      fill="currentColor"
      viewBox="0 0 15 16"
    >
      <g fillRule="evenodd" clipPath="url(#clip0_821_1979)" clipRule="evenodd">
        <path d="M12.006 3.477c-.059-.059-.094-.118-.094-.2 0-.082.035-.14.094-.199a.337.337 0 01.434 0c.058.059.093.117.093.2 0 .081-.035.14-.093.199a.365.365 0 01-.211.082.236.236 0 01-.223-.082zM11.256 4.285a.306.306 0 01-.082-.2c0-.081.035-.14.082-.198a.29.29 0 01.398 0 .306.306 0 01.082.199c0 .082-.035.14-.082.2a.306.306 0 01-.199.081.306.306 0 01-.2-.082zM10.435 5.059a.283.283 0 01-.082-.2c0-.082.036-.14.082-.199a.29.29 0 01.399 0 .283.283 0 01.082.2c0 .081-.035.14-.082.199a.257.257 0 01-.2.082.283.283 0 01-.199-.082zM9.65 5.844a.25.25 0 01-.093-.2c0-.082.035-.14.093-.199a.337.337 0 01.434 0 .25.25 0 01.094.2.25.25 0 01-.094.199.3.3 0 01-.211.082c-.082 0-.152-.012-.223-.082zM8.9 6.629c-.058-.047-.082-.117-.082-.2 0-.081.036-.14.082-.199a.29.29 0 01.399 0c.058.047.082.118.082.2a.283.283 0 01-.082.199c-.047.059-.117.082-.2.082a.198.198 0 01-.199-.082zM7.998 7.215c0-.082.035-.14.082-.2a.29.29 0 01.399 0 .257.257 0 01.082.2c0 .082-.036.14-.082.2a.283.283 0 01-.2.081.306.306 0 01-.199-.082c-.059-.047-.082-.117-.082-.2zM6.533 8.95a.283.283 0 01-.082-.2c0-.082.035-.14.082-.2a.29.29 0 01.399 0 .257.257 0 01.082.2c0 .082-.035.14-.082.2-.047.058-.118.081-.2.081-.07.012-.14-.011-.199-.082zM5.725 9.734a.25.25 0 01-.094-.199c0-.082.035-.14.094-.2a.337.337 0 01.433 0c.059.06.094.118.094.2 0 .082-.035.14-.094.2a.3.3 0 01-.21.081.255.255 0 01-.223-.082zM4.963 10.531a.283.283 0 010-.398.29.29 0 01.398 0 .283.283 0 01.082.199c0 .082-.035.14-.082.2a.257.257 0 01-.199.081c-.082 0-.129-.035-.2-.082zM4.177 11.316c-.058-.046-.082-.117-.082-.199s.035-.14.082-.199a.29.29 0 01.399 0 .306.306 0 01.082.2.283.283 0 01-.082.198.257.257 0 01-.2.082c-.07 0-.152-.023-.199-.082zM3.369 12.102a.25.25 0 01-.094-.2c0-.082.035-.14.094-.199.117-.105.304-.105.41 0 .058.059.094.117.094.2a.25.25 0 01-.094.199.366.366 0 01-.211.082c-.082 0-.152-.024-.2-.082zM2.595 12.887a.257.257 0 01-.082-.2c0-.082.035-.14.082-.199a.29.29 0 01.399 0 .257.257 0 01.082.2c0 .082-.035.14-.082.199a.283.283 0 01-.2.082c-.058.011-.128-.024-.199-.082zM2.994 3.477a.306.306 0 00.082-.2.306.306 0 00-.082-.199.29.29 0 00-.399 0 .257.257 0 00-.082.2c0 .081.035.14.082.199a.283.283 0 00.2.082c.081.011.152-.012.199-.082zM3.78 4.285c.058-.058.093-.117.093-.2 0-.081-.035-.14-.094-.198a.337.337 0 00-.433 0c-.059.058-.094.117-.094.199s.035.14.094.2c.058.046.14.081.21.081a.464.464 0 00.223-.082zM4.576 5.059a.283.283 0 00.082-.2.306.306 0 00-.082-.199.29.29 0 00-.399 0 .283.283 0 00-.082.2c0 .081.035.14.082.199a.257.257 0 00.2.082c.07 0 .14-.036.199-.082zM5.361 5.844a.283.283 0 00.082-.2.306.306 0 00-.082-.199.29.29 0 00-.398 0 .283.283 0 000 .399.257.257 0 00.2.082c.07 0 .14-.012.198-.082zM6.135 6.629a.25.25 0 00.094-.2c0-.081-.036-.14-.094-.199a.305.305 0 00-.41 0 .25.25 0 00-.094.2.25.25 0 00.094.199.3.3 0 00.21.082.198.198 0 00.2-.082zM7.014 7.215a.306.306 0 00-.082-.2.29.29 0 00-.399 0 .257.257 0 00-.082.2c0 .082.035.14.082.2a.283.283 0 00.2.081c.081 0 .14-.035.199-.082.058-.047.082-.117.082-.2zM7.717 8.21a.257.257 0 00.082-.198.306.306 0 00-.082-.2.29.29 0 00-.399 0 .257.257 0 00-.082.2c0 .082.035.14.082.199a.283.283 0 00.399 0zM8.502 8.95a.25.25 0 00.094-.2c0-.082-.035-.14-.094-.2-.117-.105-.305-.105-.41 0-.059.06-.094.118-.094.2 0 .082.035.14.094.2a.3.3 0 00.21.081.216.216 0 00.2-.082zM9.299 9.734a.283.283 0 00.082-.199.306.306 0 00-.082-.2.29.29 0 00-.399 0 .306.306 0 00-.082.2c0 .082.036.14.082.2a.257.257 0 00.2.081c.058.012.14-.023.199-.082zM10.084 10.531a.283.283 0 000-.398.29.29 0 00-.399 0 .283.283 0 00-.082.199c0 .082.035.14.082.2a.257.257 0 00.2.081c.081 0 .14-.035.199-.082zM10.822 11.316c.059-.046.082-.117.082-.199a.306.306 0 00-.082-.199.29.29 0 00-.398 0 .306.306 0 00-.082.2c0 .081.035.152.082.198a.257.257 0 00.199.082c.07 0 .152-.023.2-.082zM11.654 12.102c.059-.047.082-.118.082-.2a.306.306 0 00-.082-.199.29.29 0 00-.398 0 .257.257 0 00-.082.2c0 .081.035.152.082.199a.283.283 0 00.2.082c.081 0 .151-.024.198-.082zM12.44 12.887c.058-.059.093-.117.093-.2 0-.082-.035-.14-.093-.199-.118-.105-.305-.105-.41 0-.06.059-.095.117-.095.2 0 .082.036.14.094.199.059.047.14.082.211.082.059.011.13-.024.2-.082zM4.857 3.7c.797-.528 1.676-.774 2.649-.786.95 0 1.828.258 2.648.785l1.688-1.687C10.518 1.004 9.088.5 7.506.5c-1.582 0-3.035.504-4.324 1.512l1.675 1.687zM3.17 10.625A4.665 4.665 0 012.373 8c0-.95.258-1.828.797-2.625L1.494 3.699C.51 4.99.018 6.418.018 8.012c0 1.57.492 3.011 1.488 4.324l1.664-1.711zM10.143 12.3a4.71 4.71 0 01-2.625.833c-.973 0-1.864-.258-2.66-.82L3.17 13.988c1.3 1.02 2.754 1.524 4.348 1.512 1.582-.012 3.011-.527 4.3-1.512l-1.675-1.687zM11.795 5.352c.539.82.82 1.71.797 2.671a4.71 4.71 0 01-.797 2.579l1.687 1.675c.997-1.289 1.512-2.718 1.512-4.289.012-1.593-.492-3.047-1.512-4.347l-1.687 1.71zM13.553 12.828c.644 0 1.183.527 1.183 1.184 0 .644-.527 1.183-1.183 1.183a1.188 1.188 0 01-1.184-1.183 1.18 1.18 0 011.184-1.184zM1.482 12.828c.645 0 1.172.527 1.172 1.184 0 .644-.527 1.183-1.172 1.183a1.178 1.178 0 01-1.171-1.183c0-.657.527-1.184 1.171-1.184zM13.576.758c.645 0 1.172.527 1.172 1.183 0 .657-.527 1.184-1.172 1.184a1.178 1.178 0 01-1.172-1.184c0-.656.528-1.183 1.172-1.183zM1.459.758c.645 0 1.184.527 1.184 1.172 0 .644-.528 1.172-1.184 1.172A1.185 1.185 0 01.275 1.93C.275 1.285.803.758 1.46.758z"></path>
      </g>
      <defs>
        <clipPath id="clip0_821_1979">
          <path d="M0 0H14.965V15H0z" transform="translate(.018 .5)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
